import React, { useState } from "react";
import { Volume2, UserCircle2, Music2, Plus } from "lucide-react";
import { useLang } from "@/App";

const ICONS = [Volume2, UserCircle2, Music2];

export default function Education() {
  const { t } = useLang();
  const [openIdx, setOpenIdx] = useState(null);
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="education-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-widest text-sky-700">
            {t.education.kicker}
          </p>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold tracking-tight text-blue-950 leading-[1.1]">
            {t.education.title}
          </h2>
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {t.education.items.map((item, i) => {
            const Icon = ICONS[i] || Volume2;
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                onClick={() => setOpenIdx(isOpen ? null : i)}
                className="group cursor-pointer rounded-2xl border border-slate-200 bg-slate-50 p-8 hover:bg-white hover:shadow-md transition-all"
                data-testid={`education-card-${i}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="grid place-items-center w-14 h-14 rounded-2xl bg-blue-900 text-white">
                    <Icon className="w-7 h-7" />
                  </div>
                  <Plus className={`w-5 h-5 text-slate-400 transition-transform ${isOpen ? "rotate-45" : "group-hover:rotate-45"}`} />
                </div>
                <h3 className="mt-6 text-2xl font-bold text-slate-900">{item.title}</h3>
                <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-60 opacity-100 mt-3" : "max-h-0 opacity-0 group-hover:max-h-60 group-hover:opacity-100 group-hover:mt-3"}`}>
                  <p className="text-base text-slate-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
